import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer id="footer" class="footer position-relative light-background">
        <div class="container footer-top">
          <div class="row gy-4">
            <div class="col-lg-5 col-md-12 footer-about">
              <Link to="index.html" class="logo d-flex align-items-center">
                <img src="../../assets/img/logo2.jpg" alt="img"></img>
              </Link>
              <p>
                We are a trusted waterproofing company specializing in
                protecting residential, commercial, and industrial properties
                from water damage. With a range of solutions like terrace,
                basement, and bathroom waterproofing, we ensure your spaces
                remain dry, safe, and structurally sound. Our expert team uses
                advanced techniques and high-quality materials to provide
                long-lasting protection against leaks, dampness, and moisture,
                keeping your property secure for years to come.
              </p>
              <div class="social-links d-flex mt-4">
                <Link to="">
                  <i class="bi bi-twitter-x"></i>
                </Link>
                <Link to="">
                  <i class="bi bi-facebook"></i>
                </Link>
                <Link to="">
                  <i class="bi bi-instagram"></i>
                </Link>
                <Link to="">
                  <i class="bi bi-linkedin"></i>
                </Link>
              </div>
            </div>

            <div class="col-lg-3 col-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/About">About us</Link>
                </li>
                <li>
                  <Link to="/Service">Services</Link>
                </li>
                <li>
                  <Link to="/Ourproject">Gallery</Link>
                </li>
                <li>
                  <Link to="/Contact">Contact </Link>
                </li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-12 footer-contact text-center text-md-start">
              <h4>Contact Us</h4>
              <p> Plot no. 90, </p>
              <p>arcot Road </p>
              <p>Ekkattutangal, Chennai - 602 106. </p>
              <p class="mt-4">
                Contact:
                <Link to="tel:+91 8907654321">9876543210</Link>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <Link to="mailto:Suresh@feniceshieldchemical.com">
                  feniceshieldchemical.com
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div class="container copyright text-center mt-4">
          <p>
            © <span>Copyright</span>{" "}
            <strong class="sitename">Fenice shield chemicals Pvt Ltd </strong>
            <span>All Rights Reserved</span>
          </p>
          <div class="credits">
            Designed by{" "}
            <Link to="https://brandingworld.net/">Branding world</Link>
          </div>
        </div>
      </footer>
      ;
    </div>
  );
};

export default Footer;
